export const LIMITED_PEER_ERROR_NAME = 'LimitedPeerConnectionError';
import { RTC_OFF } from './constants';

/**
 * This is a stub that emulates interface of PeerConnection class,
 * replying to any message with an error to let the sender
 * know that this client can't make calls.
 */
export default class LimitedPeerConnection {
  dispatch() {
    throw new Error(LIMITED_PEER_ERROR_NAME);
  }

  setLocalAudioStream() { return Promise.resolve(); }
  setLocalVideoStream() { return Promise.resolve(); }
  setLocalScreenStream() { return Promise.resolve(); }
  getConnectionState() { return RTC_OFF; }
  check() { return Promise.resolve(); }
  close() {}
}
